import { BottomSheetType, ButtonTypeTokens, ButtonWidthTypeToken, SizeTypeTokens, WIDGET, } from '@voltmoney/schema';
import React from 'react';
import { View } from 'react-native';
export const args = {
    type: BottomSheetType.MOBILE,
    children: [
        React.createElement(View, { style: {
                backgroundColor: '#000',
                height: 50,
                width: 100,
            } }),
    ],
    initialOffset: 0.35,
    finalOffSet: 0.95,
    widgetHeaderItems: [
        {
            id: 'button1',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.LargeOutline,
            },
        },
    ],
    widgetItems: [
        {
            id: 'button1',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.LargeOutline,
            },
        },
        {
            id: 'button2',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.LargeOutline,
            },
        },
        {
            id: 'button3',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.LargeOutline,
            },
        },
        {
            id: 'button4',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.LargeOutline,
            },
        },
        {
            id: 'button5',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.LargeOutline,
            },
        },
        {
            id: 'button6',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.LargeOutline,
            },
        },
        {
            id: 'button7',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.LargeOutline,
            },
        },
        {
            id: 'button8',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.LargeOutline,
            },
        },
    ],
    padding: {
        horizontal: SizeTypeTokens.XXXL,
    },
};
export const argTypes = {};
